import React from 'react';
import { Asset } from './types';
import AssetIcon from './AssetIcon';
import DownloadSVG from 'shared/components/svg/DownloadSVG';

interface AssetDownloadIconProps {
	asset: Asset;
	assetIconClasses?: string;
	downloadIconClasses?: string;
}

/**
 * Icon for downloading assets.
 */
export default function AssetDownloadIcon(props: AssetDownloadIconProps) {
	const { asset, assetIconClasses, downloadIconClasses } = props;

	return (
		<>
			<AssetIcon asset={asset} assetIconClasses={assetIconClasses} />
			<div className={`${downloadIconClasses}-wrapper`}>
				<DownloadSVG className={downloadIconClasses} />
			</div>
		</>
	);
}
